module.exports = __webpack_public_path__ + "static/media/END CAP 57.60 BULL NOSE FOR 290 TUBE FOR SDS 300.da27851d.jpg";